import {
  makeStyles,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Divider,
  Button,
} from "@material-ui/core";
import AlertDialog from "../../../../../../../Components/CustomDialog";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import FormGenerator from "../../../../../../../Components/FormGenerator";
import { useSelector } from "react-redux";
import { useState, useEffect, useCallback } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      display: "flex",
    },
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  meetingItems: {
    display: "flex",
    alignItems: "baseline",
    paddingBottom: "10px",
  },
  accordionWrapper: {
    flexGrow: 1,
    border: "1px solid #ccc",
    borderBottom: "0",
    "& > div": {
      minHeight: "0px !important",
    },
    "& > div > div:first-child": {
      minHeight: "0px !important",
      margin: 0,
    },
  },
  accordionTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
}));

const dummyObj = {
  Organisation_meeting_or_Call_dates: [
    {
      Organisation_meeting_or_Call_dates_id: 795,
      Organisation_meeting_or_Call_dates_detail_of_actions: [],
      Organisation_meeting_or_Call_dates_meeting_datetime:
        "2023-09-14 01:01:00 UTC",
      Organisation_meeting_or_Call_dates_start_time: "2023-09-13T01:01:58.519Z",
      Organisation_meeting_or_Call_dates_end_time: "2023-09-13T01:01:58.534Z",
      Organisation_meeting_or_Call_dates_description: "",
      Organisation_meeting_or_Call_dates_briefing: "",
      Organisation_meeting_or_Call_dates_who_involved: "",
      Organisation_meeting_or_Call_dates_prep_required: "",
      Organisation_meeting_or_Call_dates_temporary_owner: "",
      Organisation_meeting_or_Call_dates_platform: "BlueJeans",
    },
    {
      Organisation_meeting_or_Call_dates_id: 796,
      Organisation_meeting_or_Call_dates_detail_of_actions: [],
      Organisation_meeting_or_Call_dates_meeting_datetime:
        "2023-09-14 01:01:00 UTC",
      Organisation_meeting_or_Call_dates_start_time: "2023-09-13T01:01:58.519Z",
      Organisation_meeting_or_Call_dates_end_time: "2023-09-13T01:01:58.534Z",
      Organisation_meeting_or_Call_dates_description: "",
      Organisation_meeting_or_Call_dates_briefing: "",
      Organisation_meeting_or_Call_dates_who_involved: "",
      Organisation_meeting_or_Call_dates_prep_required: "",
      Organisation_meeting_or_Call_dates_temporary_owner: "",
      Organisation_meeting_or_Call_dates_platform: "BlueJeans",
    },
  ],
};
const MeetingDetailsComponent = (props) => {
  const classes = useStyles();

  const { name, handleChange, label } = props;
  const [callMeetingItem, setCallMeetingItem] = useState(
    dummyObj.Organisation_meeting_or_Call_dates || []
  );
  const [dialogState, setDialogState] = useState(undefined);
  const [dialogStateActionsMeeting, setDialogStateActionsMeeting] =
    useState(undefined);

  const handleInputChange = useCallback(
    (value, index, type, perentIndex) => {
      setCallMeetingItem((prevState) => {
        const keyIndex = [
          "meeting_datetime",
          "start_time",
          "end_time",
          "description",
          "who_involved",
          "prep_required",
          "temporary_owner",
          "platform",
          "briefing",
        ];
        prevState[perentIndex] = { ...prevState[perentIndex] };
        prevState[perentIndex][keyIndex[index]] = value;
        return [...prevState];
      });
      callMeetingItem?.length && handleChange(callMeetingItem, 0, "", name);
    },
    [callMeetingItem]
  );

  const handleMeeting = (isAdd, index) => {
    if (isAdd) {
      const newCall = {
        meeting_datetime: "",
        start_time: "",
        end_time: "",
        description: "",
        who_involved: "",
        prep_required: "",
        temporary_owner: "",
        platform: [],
        briefing: "",
        expanded: true,
      };
      const newItem = [
        ...callMeetingItem.map((item) => ({ ...item, expanded: false })),
        ...[newCall],
      ];
      setCallMeetingItem(newItem);
      handleChange(newItem, 0, "", name);
    } else {
      callMeetingItem.splice(index, 1);
      callMeetingItem.map((item) => ({ ...item, expanded: false }));
      handleChange(callMeetingItem, 0, "", name);
      setCallMeetingItem([...callMeetingItem]);
    }
  };

  const handleChild = (isAdd, index, parentIndex) => {
    if (isAdd) {
      const newCall = {
        deadline_date: "",
        description: "",
        who: "",
        completed: false,
      };
      let updatedData = { ...callMeetingItem[parentIndex] };
      if (updatedData["detail_of_actions"]?.length) {
        updatedData["detail_of_actions"] = [
          ...updatedData["detail_of_actions"],
          ...[newCall],
        ];
      } else {
        updatedData["detail_of_actions"] = [newCall];
      }
      callMeetingItem[parentIndex] = { ...updatedData };
      setCallMeetingItem(callMeetingItem);
      handleChange(callMeetingItem, parentIndex, "", name);
    } else {
      callMeetingItem[parentIndex]["detail_of_actions"].splice(index, 1);
      handleChange(callMeetingItem, 0, "", name);
      setCallMeetingItem([...callMeetingItem]);
    }
  };

  const handleChildInputChange = useCallback(
    (value, index, type, parentIndex) => {
      const ParentIndexIds = parentIndex.split("-");
      setCallMeetingItem((prevState) => {
        const keyIndex = ["deadline_date", "description", "who", "completed"];
        const meetingItem = { ...prevState[ParentIndexIds[0]] };
        meetingItem["detail_of_actions"][ParentIndexIds[1]][keyIndex[index]] =
          value;
        prevState[ParentIndexIds[0]] = { ...meetingItem };
        return [...prevState];
      });
      callMeetingItem?.length &&
        handleChange(callMeetingItem, ParentIndexIds[0], "", name);
    },
    [callMeetingItem]
  );

  const formArray = [
    {
      componentType: "datePicker",
      type: "text",
      label: "Deadline date",
      name: "deadline_date",
      handleChange: handleChildInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Description",
      name: "description",
      placeholder: "Description",
      multiline: true,
      handleChange: handleChildInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Who",
      name: "who",
      placeholder: "Who",
      multiline: true,
      handleChange: handleChildInputChange,
    },
    {
      componentType: "singleCheckbox",
      label: "Completed",
      value: false,
      name: "completed",
      onChange: handleChildInputChange,
    },
  ];

  const handleCollapse = (index) => {
    setCallMeetingItem((oldValue) => [
      ...oldValue.map((item, itemIndex) => {
        if (itemIndex === index)
          return { ...item, expanded: item?.expanded ? !item.expanded : true };
        else return { ...item, expanded: false };
      }),
    ]);
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        flexDirection: "column",
        alignItems: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "0.5rem",
          marginBottom: "1rem",
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          style={{ fontSize: "16px", fontWeight: "bold" }}
        >
          Meeting/Call dates
        </Typography>

        <AddCircleIcon
          type="submit"
          onClick={() => handleMeeting(true, 0)}
          fontSize="large"
          color="primary"
          style={{ cursor: "pointer" }}
        />
      </div>
      <Grid
        container
        className={classes.gridRoot}
        style={{ flexGrow: 1, overflow: "scroll" }}
        spacing={3}
      >
        <Grid item xs={12} md={12}>
          {callMeetingItem?.map((item, index) => {
            const formInputFields =
              props?.componentObject?.length &&
              props?.componentObject.map((fieldItem) => ({
                ...fieldItem,
                handleChange: handleInputChange,
                value: item[fieldItem.name],
              }));
            return (
              <div className={classes.meetingItems}>
                <Accordion
                  className={classes.accordionWrapper}
                  expanded={item?.expanded}
                  onChange={(e) => {
                    handleCollapse(index);
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={classes.accordionTitle}>
                      Meeting/Call dates #{index + 1}
                      <AddCircleIcon
                        type="submit"
                        onClick={(e) => {
                          e.stopPropagation();
                          setDialogState({
                            isOpen: true,
                            index,
                          });
                        }}
                        fontSize="large"
                        color="error"
                        style={{
                          cursor: "pointer",
                          transform: "rotate(45deg)",
                        }}
                      />
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid item xs={12}>
                      <FormGenerator
                        pIndex={index}
                        children={formInputFields}
                        handleNext={props.handleNext}
                        nextIndex={6}
                        setId={props.setId}
                        style={{
                          width: "100%",
                        }}
                        moduleName="organization"
                      />
                      <Grid container>
                        <Grid item xs={12} md={4}>
                          Detail of action
                        </Grid>
                        <Grid item xs={12} md={8}>
                          {item?.detail_of_actions?.length
                            ? item?.detail_of_actions?.map(
                                (childItem, childIndex) => {
                                  const formInputFields =
                                    formArray?.length &&
                                    formArray.map((fieldItem) => ({
                                      ...fieldItem,
                                      handleChange: handleChildInputChange,
                                      value: childItem[fieldItem.name],
                                    }));
                                  return (
                                    <>
                                      <Grid container>
                                        <Grid item xs={11}>
                                          <FormGenerator
                                            pIndex={`${index}-${childIndex}`}
                                            children={formInputFields}
                                            handleNext={props.handleNext}
                                            nextIndex={6}
                                            setId={props.setId}
                                            style={
                                              {
                                                // width: "100%",
                                              }
                                            }
                                          />
                                        </Grid>
                                        <Grid item xs={1}>
                                          <AddCircleIcon
                                            type="submit"
                                            onClick={() =>
                                              setDialogStateActionsMeeting({
                                                isOpen: true,
                                                index,
                                                childIndex,
                                              })
                                            }
                                            fontSize="large"
                                            color="error"
                                            style={{
                                              cursor: "pointer",
                                              transform: "rotate(45deg)",
                                            }}
                                          />
                                        </Grid>
                                      </Grid>
                                      <Divider
                                        style={{ marginBottom: "20px" }}
                                      />
                                    </>
                                  );
                                }
                              )
                            : null}
                          <AddCircleIcon
                            type="submit"
                            onClick={() => handleChild(true, 0, index)}
                            fontSize="large"
                            color="primary"
                            style={{ cursor: "pointer" }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </div>
            );
          })}
        </Grid>
        {dialogState?.isOpen && (
          <AlertDialog
            dialogState={dialogState}
            dialogContent={`Are you sure you want to delete this meeting details?`}
            handleSubmit={(value) => handleMeeting(false, value?.index)}
            handleClose={() => setDialogState(undefined)}
          />
        )}
        {dialogStateActionsMeeting?.isOpen && (
          <AlertDialog
            dialogState={dialogStateActionsMeeting}
            dialogContent={`Are you sure you want to delete this detail of action?`}
            handleSubmit={(value) =>
              handleChild(false, value?.childIndex, value?.index)
            }
            handleClose={() => setDialogStateActionsMeeting(undefined)}
          />
        )}
      </Grid>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "0.5rem",
          marginBottom: "1rem",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ textTransform: "none" }}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default MeetingDetailsComponent;
